import React from "react";
import DownloadMobileApp from "~/src/uiblocks/landing/DownloadMobileApp";

const HeroSection2 = () => {
  return (
    <>
      <script
        async
        src="https://cse.google.com/cse.js?cx=264be1db82ce84ca3"
      >
      </script>

      {/* Hero Section */}
      <section className="relative pt-12 pb-12 overflow-hidden">
        {/*<div className="absolute inset-0 bg-gradient-to-r from-blue-100/30 to-blue-200/30"></div>*/}
        <div className="relative max-w-6xl mx-auto px-4">
          <div className="text-center">
            <div>
              <h2 className="text-5xl md:text-5xl font-bold text-gray-900 mb-6">
                Discover attractions
                <br />
                <span className="text-blue-600">
                  {" "}near you!{" "}
                </span>
              </h2>
              <p className="text-xl font-semibold text-gray-700 mb-2 leading-relaxed">
                {/*Explore beyond the obvious - even without a plan.*/}
                {/*Create personalized routes based on your preferences.*/}
                WayPick builds smart, personalized routes for your day.
              </p>
              <p className="text-gray-400 italic mb-8 text-l">Let AI do the planning - so you can focus on the
                experience.</p>
              <div className="gap-4 justify-center">
                {/*<button*/}
                {/*  type="button"*/}
                {/*  onClick={() => document.getElementById('route-form')?.scrollIntoView({ behavior: 'smooth' })}*/}
                {/*  className="bg-blue-600 text-white px-8 py-4 rounded-xl font-semibold hover:bg-blue-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"*/}
                {/*>*/}
                {/*  Plan My Route*/}
                {/*</button>*/}

                {/*<Link*/}
                {/*  to={M_URI_FULL_ROOT_PATH}*/}
                {/*  onClick={(e) => {*/}
                {/*    trackGAClick("landing", 'plan-my-route');*/}
                {/*  }}*/}
                {/*  className="bg-blue-600 text-white px-8 py-4 rounded-xl font-semibold hover:bg-blue-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"*/}
                {/*>*/}
                {/*  Discover attractions*/}
                {/*</Link>*/}

                {/*<button className="border-2 border-blue-300 text-blue-600 px-8 py-4 rounded-xl font-semibold hover:border-blue-500 hover:bg-blue-50 transition-all duration-200">*/}
                {/*  View Examples*/}
                {/*</button>*/}
              </div>
            </div>
          </div>

          <DownloadMobileApp />

          <div className="flex justify-center flex-wrap">
            <img
              src="images/landing/europe_collage.jpeg"
              className="flex pt-12 justify-center"
            />

          </div>

          {/*<div className="pt-12">*/}
          {/*  /!*<p className="text-gray-500 italic mb-8 text-xl">Search routes in</p>*!/*/}
          {/*  <div className="gcse-search"></div>*/}
          {/*</div>*/}
        </div>
      </section>
    </>
  );
}

export default HeroSection2;